import {
  AdminContact,
  ApiResponse,
  CreateContactRequest,
  PaginationParams,
  UpdateContactRequest,
} from "../../types/admin";
import httpClient from "../httpClient";
import { sanitizeArrayResponse } from "./helpers";

export const contactsApi = {
  getAll: async (params?: PaginationParams): Promise<ApiResponse<AdminContact[]>> => {
    const response = await httpClient.get<AdminContact[]>("/contacts", params);
    return sanitizeArrayResponse(response);
  },

  getById: (id: string | number): Promise<ApiResponse<AdminContact>> =>
    httpClient.get(`/contacts/${id}`),

  create: (contact: CreateContactRequest): Promise<ApiResponse<AdminContact>> =>
    httpClient.post("/contacts", contact),

  update: (id: string | number, contact: UpdateContactRequest): Promise<ApiResponse<AdminContact>> =>
    httpClient.put(`/contacts/${id}`, contact),

  delete: (id: string | number): Promise<ApiResponse<void>> =>
    httpClient.delete(`/contacts/${id}`),
};
